import Paper from '@mui/material/Paper';
import classes from './ccf-agent-skills.module.scss';
import { CcfDirectorySearch } from '../../../ccf-directory/ccf-directory-search/ccf-directory-search';
import { useState } from 'react';
import {
  CcfAgentSettingsChatIcon,
  CcfAgentSettingsInboundChatIcon,
  CcfAgentSettingsPhoneInboundIcon,
  CcfAgentSettingsPhoneOutboundIcon,
  CcfCallOutboundIcon,
  CcfChatIcon,
  CcfInboundIcon,
  CcfOutboundIcon,
  CcfPhoneInboundIcon,
  CcfPhoneOutboundIcon,
  CcfTable,
  CcfTypography,
  RowDataStructure,
  useTranslator,
} from '@nice-ccf/ui-controls';
import agentSkillsStyles from './ccf-agent-skills.styles';
import { Box, useTheme } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfAgentSkillsProps {}

/**
 * @example CcfAVNotifications()
 * @returns
 */
export function CcfAgentSkills(props: CcfAgentSkillsProps) {
  const [searchContent, updateSearchContent] = useState<string>('');
  const [translate] = useTranslator();
  const theme = useTheme();
  const styles = agentSkillsStyles(theme);
  const rowData: RowDataStructure[] = [];
  const rows: any = [
    {
      id: 1,
      skillName: 'Aditi_IBPhone',
      skillIcon: <CcfAgentSettingsPhoneInboundIcon />,
    },
    {
      id: 2,
      skillName: 'CCF_Chat_Queue',
      skillIcon: <CcfAgentSettingsChatIcon />,
    },
    {
      id: 3,
      skillName: 'Eternals_PC',
      skillIcon: <CcfAgentSettingsPhoneOutboundIcon />,
    },
    {
      id: 4,
      skillName: 'Eternals_Chat',
      skillIcon: <CcfAgentSettingsInboundChatIcon />,
    }
  ];
  if (rows.length > 0) {
    rows.forEach((skill: any, index: number) => {
      const dataStructured = [
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: 'auto',
          }}
        >
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            {skill.skillIcon}
            <CcfTypography
              variant="h4"
              sx={styles.iconHeaderClasses}
              title={skill.skillName}
              aria-label={skill.skillName}
            >
              {skill.skillName}
            </CcfTypography>
          </Box>
        </Box>,
      ];
      const object: any = { data: dataStructured };
      rowData.push(object);
    });
  }

  return (
    <Paper
      square
      elevation={0}
      classes={{ root: classes.agentSkillsContainer }}
    >
      <CcfDirectorySearch
        updateSearchQuery={updateSearchContent}
        placeHolder= {translate("search")}
        isFilterIcon
      />
      {/* <div style={{width:'100%', backgroundColor:'#d9ebf5'}}>
        <CcfTypography className={classes.skillsTitle}>Assigned Skills {3}</CcfTypography>
      </div> */}
      <CcfTable
        colWidths={['100%']}
        headersData={[translate('AssignedSkills') + ' (4)']}
        rowsData={rowData}
        tableStyle={styles.tableStyle}
        rowStyle={styles.tableBodyRow}
        headerStyle={styles.tableHeadRow}
        containerStyle={styles.customTableContainer}
        isHideSortIcon={true}
      ></CcfTable>
    </Paper>
  );
}

export default CcfAgentSkills;
